$(document).ready(function () {
  function syncActiveBlock(group, value) {
    $('.product-selector_outer[data="' + group + '"]').each(function () {
      $(this).find(".product-selector_block").removeClass("active");
      $(this).find('.product-selector_block[data-id="' + value + '"]').addClass("active");
    });
  }

  function syncMode(isSub) {
    $(".pp_var_autoship").toggleClass("disabled", !isSub);

    if (isSub) {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    }
  }

  $(document).on("click", ".product-selector_block", function () {
    var $block = $(this);
    var $outer = $block.closest(".product-selector_outer");
    var group = $outer.attr("data");
    var currentId = $block.attr("data-id");

    syncActiveBlock(group, currentId);
  });

  $(document).on("click", ".pp_var_autoship", function () {
    var isCurrentlyDisabled = $(this).hasClass("disabled");
    syncMode(isCurrentlyDisabled);
  });

  $(document).on("click", ".product-selector_atc", function () {
    var $button = $(this);
    var $activeOuter = $('.product-selector_outer.active_block').first();
    var $activeBlock = $activeOuter.find(".product-selector_block.active").first();

    if (!$activeOuter.length || !$activeBlock.length) {
      alert("Please select an option.");
      return;
    }

    if ($button.attr("data-mode-champs") === "true") {
      var newUrl = $activeBlock.attr("data-champs-url");
      if (newUrl) {
        window.location.href = newUrl;
      }
      return;
    }

    var currentId = $activeBlock.attr("data-id");
    var mode = $activeOuter.attr("data");
    var currentSellingPlan = $activeBlock.attr("data-selling-plan");

    var data = {
      id: currentId,
      quantity: 1
    };

    if (mode === "sub" && currentSellingPlan) {
      data.selling_plan = currentSellingPlan;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {},
      error: function () {
        alert("Error adding item to the cart.");
      }
    });
  });
});

